export enum SubscriptionTopic {
    MyChannels = 'my-channels',
    DailyChatUK = 'daily-chat-uk',
    DailyChatUS = 'daily-chat-us',
    WeeklyChatUK = 'weekly-chat-uk',
    WeeklyChatUS = 'weekly-chat-us',
}
